import EmblaCarousel from "embla-carousel"
import { addDotBtnsAndClickHandlers } from "./dots"

export default class Carousel {
  initCarousel(node) {
    const viewportNode = node.querySelector(".embla__viewport")

    const leftEdge = node.querySelector(".embla__edge--start")
    const rightEdge = node.querySelector(".embla__edge--end")

    const dotsNode = node.querySelector(".embla__dots")

    if (node && viewportNode) {
      const emblaApi = EmblaCarousel(viewportNode, {
        align: "start",
        dragThreshold: 5,
      })

      emblaApi.on("init", () => {
        this.toggleEdges(leftEdge, rightEdge, emblaApi)
      })

      emblaApi.on("resize", () => {
        this.toggleEdges(leftEdge, rightEdge, emblaApi)
      })

      emblaApi.on("scroll", () => {
        this.toggleEdges(leftEdge, rightEdge, emblaApi)
      })

      const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode)

      emblaApi.on("destroy", removeDotBtnsAndClickHandlers)
    }
  }

  toggleEdges(start, end, emblaApi) {
    const progress = Math.round(emblaApi.scrollProgress() * 100)

    if (progress <= 0) {
      start.classList.remove("is-visible")
    } else {
      start.classList.add("is-visible")
    }

    if (progress === 100) {
      end.classList.remove("is-visible")
    } else {
      end.classList.add("is-visible")
    }
  }
}
